export function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log('Impossible to parse JWT Token');
        return null;
    }
}
export function authRepositoryFactory(deps) {
    async function doLogin() {
        try {
            await deps.auth0Client.loginWithRedirect();
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doExtranetLogin() {
        try {
            await deps.auth0Client.loginWithRedirect({
                authorizationParams: {
                    connection: deps.auth0Config.extranetConnection,
                },
            });
            localStorage.setItem('afterLoginPath', '/');
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doSmagLogin() {
        try {
            await deps.auth0Client.loginWithRedirect({
                authorizationParams: { connection: deps.auth0Config.smagConnection },
            });
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doRegister() {
        try {
            await deps.auth0Client.loginWithRedirect({
                authorizationParams: { screen_hint: 'signup' },
            });
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doLogout(opts) {
        localStorage.removeItem('targetShoppingListId');
        localStorage.removeItem('targetMembershipNumber');
        localStorage.removeItem('targetCustomer');
        localStorage.removeItem('afterLoginPath');
        const returnToComputed = opts?.returnTo || window.location.origin;
        await deps.auth0Client.logout({
            logoutParams: { returnTo: returnToComputed },
        });
    }
    async function doAuth0Callback() {
        await deps.auth0Client.handleRedirectCallback();
    }
    async function isAuthenticated() {
        return deps.auth0Client.isAuthenticated();
    }
    async function getUserAuth0Token() {
        const accessToken = await deps.auth0Client.getTokenSilently();
        const parsedAccessToken = parseJwt(accessToken); // TODO remplacer
        return accessToken ? { scopes: parsedAccessToken?.scope.split(' ') || [], accessToken } : null;
    }
    return {
        doLogin,
        doExtranetLogin,
        doSmagLogin,
        doRegister,
        doLogout,
        doAuth0Callback,
        isAuthenticated,
        getUserAuth0Token,
    };
}
//# sourceMappingURL=auth.repository.factory.js.map